import React from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { useModal, openConfirmPopup } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { permissions } from '@vlabs/shared/config';

import { GarbageCollectionStepperForm } from './GarbageCollectionStepperForm';

export function GarbageCollectionWidget({ afterSubmit, filters }) {
  const { t } = useTranslation();
  const modal = useModal();

  const submitForm = (values) => {
    openConfirmPopup({
      title: t('tasks:GCTask.confirmation.title'),
      message: t('tasks:GCTask.confirmation.message'),
      type: 'delete',
      onConfirm: async () => {
        await apiContainer.lunaClient.tasks.createGCTask(values);
        toast.info(t('tasks:api.GCTask.create.success'));
        modal.close();
        if (afterSubmit) afterSubmit();
      },
      confirmLabel: t('btn.ok'),
    });
  };

  return (
    <React.Fragment>
      {modal.wrap(<GarbageCollectionStepperForm
        filters={filters}
        onSubmit={submitForm}
      />)}
      <ButtonWithPermissions
        data-testid="garbageCollectionButton"
        onClick={modal.open}
        permissions={{ rules: [permissions.task.creation, permissions.face.deletion], method: 'allof' }}
      >
        {t('tasks:GCTask.button.delete_faces_from_list')}
      </ButtonWithPermissions>
    </React.Fragment>
  );
}

GarbageCollectionWidget.propTypes = {
  afterSubmit: PropTypes.func,
  filters: PropTypes.shape({
    listId: PropTypes.string,
  }),
};

GarbageCollectionWidget.defaultProps = {
  afterSubmit: undefined,
  filters: {},
};
